import { TextDimension } from './text-dimension.ts'

/**
 * Referral code that the referee applied to this subscription.
 *
 * Distinct from a customer's own referral code (every customer has one — that one is read from the
 * referral event store). This dimension carries the code the referee used
 * to land on the funnel.
 */
export const referralCodeUsedDimension = new TextDimension({
  name: 'referralCodeUsed',
  displayKeys: { name: 'dimension_name_referral_code_used' },
  considerForDifferenceComputationInUi: { client: false, partner: true, platform: true },
  includeInTrackingMessages: true,
  inputLocking: {
    lockedInQuoteFor: {},
    lockedInEndorsementFor: {
      partner: true,
      platform: true,
      client: true,
    },
    lockedInRenewalFor: {
      partner: true,
      platform: true,
      client: true,
    },
  },
} as const)

// Shape of a referral code generated by `generateSecurityToken`:
// 6 chars from a non-lookalike uppercase alphabet (no 0/O, 1/I, 5/S, 2/Z, 8/B).
const REFERRAL_CODE_PATTERN = /^[34679ACDEFGHJKLMNPQRTUVWXY]{6}$/
export const NO_REFERRAL_CODE = 'none'

export function isReferralCodeUsedFullyFilled(value: unknown): boolean {
  return value === NO_REFERRAL_CODE || (typeof value === 'string' && REFERRAL_CODE_PATTERN.test(value))
}
